

function Loading(){
    
    return (
        <div style={{marginBottom:"700px"}}>
            <h2>Loading...</h2>
        </div>
    )
}

export default Loading